import { apiGet, apiPut } from '../client';
import { MembershipResponseSchema, type Membership } from '../schemas';
import type { BillingCycle, PlanTier } from '../../lib/plan';

export const MEMBERSHIP_QUERY_KEY = ['membership'];

export async function getMembership(): Promise<Membership> {
  const response = await apiGet('/v1/business/membership', MembershipResponseSchema);
  return response.data;
}

/**
 * Owner only. The negotiated discount carries over to the new plan server-side;
 * the cycle says whether it is paid month by month or the year up front.
 * `expectedVersion` is the `planVersion` the owner had on screen
 * (docs/versiones-contra-choques.md): a different one answers 409
 * `version_conflict` with the membership as it stands, and nothing is changed.
 * The server asks for an Idempotency-Key on every write, and asking again with
 * another version is another request, so each call mints its own.
 */
export async function changeMembershipPlan(
  plan: PlanTier,
  billingCycle: BillingCycle,
  expectedVersion?: number,
): Promise<Membership> {
  const response = await apiPut(
    '/v1/business/membership',
    MembershipResponseSchema,
    { plan, billingCycle, ...(expectedVersion !== undefined ? { expectedVersion } : {}) },
    crypto.randomUUID(),
  );
  return response.data;
}
